import { ActionEventTriggerStore } from './action-event-trigger/ActionEventTriggerStore';
import { AnimationStore } from './animation/AnimationStore';
import { AppStore } from './app/AppStore';
import { AuthStore } from './auth/AuthStore';
import { BingoStore } from './bingo/BingoStore';
import { CashOfferStore } from './cash-offer/CashOfferStore';
import { CategoriesStore } from './categories/CategoriesStore';
import { ChallengesStore } from './challenges/ChallengesStore';
import { CmsStore } from './cms/CmsStore';
import { CoinBackStore } from './coin-back/CoinBackStore';
import { CoinTypeStore } from './cointype/CoinTypeStore';
import { ConfigStore } from './config/ConfigStore';
import { CrownRipsStore } from './crownrips/CrownRipsStore';
import { DailyMissionsStore } from './daily-missions/DailyMissionsStore';
import { DebugEnvStore } from './debug-env/DebugEnvStore';
import { EventTriggerStore } from './event-trigger/EventTriggerStore';
import { ExtendedOfferStore } from './extended-offer/ExtendedOfferStore';
import { FeatureManagerStore } from './feature-manager/FeatureManagerStore';
import { ForceKycStore } from './force-kyc/ForceKycStore';
import { GameStore } from './game/GameStore';
import { GameUiStore } from './game-ui/GameUiStore';
import { GamesSearchStore } from './games-search/GamesSearchStore';
import { HammersStore } from './hammers/HammersStore';
import { JackpotStore } from './jackpot/JackpotStore';
import { LandingStore } from './landing/LandingStore';
import type { LiveGeoStore } from './live-geo/LiveGeoStore';
import { liveGeoStore } from './live-geo/LiveGeoStore';
import { LocationStore } from './location/LocationStore';
import { LowBalanceStore } from './low-balance/LowBalanceStore';
import { LoyaltyProgramStore } from './loyalty/LoyaltyProgramStore';
import { MarketingConsentStore } from './marketing-consent/MarketingConsentStore';
import { MetagamesStore } from './metagames/MetagamesStore';
import { MetagamesWarmStore } from './metagames-warm/MetagamesWarmStore';
import { MinigamesStore } from './minigames/MinigamesStore';
import { MissionsStore } from './missions/MissionsStore';
import { MonetizationEventsStore } from './monetization-events/MonetizationEventsStore';
import { SportEventsStore } from './monetization-events/sport-events/SportEventsStore';
import { NotificationsStore } from './notifications/NotificationsStore';
import { OnboardingStore } from './onboarding/OnboardingStore';
import { PayRedeemStore } from './payredeem/PayRedeemStore';
import { PlinkoStore } from './plinko/PlinkoStore';
import { PocStore } from './poc/PocStore';
import { PortalStore } from './portal/PortalStore';
import { PrizeDropStore } from './prize-drop/PrizeDropStore';
import { PromotionStore } from './promotion/PromotionStore';
import { PuzzleStore } from './puzzle/PuzzleStore';
import { QuestStore } from './quest/QuestStore';
import { RecentlyPlayedStore } from './recently-played/RecentlyPlayedStore';
import { RegionStore } from './region/RegionStore';
import { RewardsStore } from './rewards/RewardsStore';
import { RiveFileStore } from './rive-file/riveFileStore';
import { RouletteStore } from './roulette/RouletteStore';
import { SofStore } from './sof/SofStore';
import { StampCardStore } from './stamp-card/StampCardStore';
import { SubscriptionStore } from './subscription/SubscriptionStore';
import { TermsOfServiceStore } from './terms-of-service/TermsOfServiceStore';
import { TournamentOfChampionsStore } from './tournament/TournamentOfChampionsStore';
import { TournamentStore } from './tournament/tournamentStore';
import { TrailStore } from './trail/TrailStore';
import { UiStore } from './ui/UiStore';
import { UserStore } from './user/UserStore';
import { UserFreeSpinsStore } from './user-free-spins/userFreeSpinsStore';
import { UserSnappyGiftsStore } from './user-snappy-gifts/UserSnappyGiftsStore';
import { WalletStore } from './wallet/WalletStore';
import { WidgetsStore } from './widgets/WidgetsStore';
import { WizardStore } from './wizard/WizardStore';

export class RootStore {
  appStore: AppStore;
  authStore: AuthStore;
  categoriesStore: CategoriesStore;
  cmsStore: CmsStore;
  configStore: ConfigStore;
  gameStore: GameStore;
  onboardingStore: OnboardingStore;
  portalStore: PortalStore;
  rewardsStore: RewardsStore;
  uiStore: UiStore;
  userStore: UserStore;
  walletStore: WalletStore;
  payRedeemStore: PayRedeemStore;
  coinTypeStore: CoinTypeStore;
  crownRipsStore: CrownRipsStore;
  wizardStore: WizardStore;
  landingStore: LandingStore;
  eventTriggerStore: EventTriggerStore;
  loyaltyProgramStore: LoyaltyProgramStore;
  tournamentStore: TournamentStore;
  tournamentOfChampionsStore: TournamentOfChampionsStore;
  dailyMissionsStore: DailyMissionsStore;
  debugEnvStore: DebugEnvStore;
  missionsStore: MissionsStore;
  promotionStore: PromotionStore;
  featureManagerStore: FeatureManagerStore;
  termsOfServiceStore: TermsOfServiceStore;
  coinBackStore: CoinBackStore;
  animationStore: AnimationStore;
  minigamesStore: MinigamesStore;
  notificationStore: NotificationsStore;
  userFreeSpinsStore: UserFreeSpinsStore;
  pocStore: PocStore;
  lowBalanceStore: LowBalanceStore;
  questStore: QuestStore;
  stampCardStore: StampCardStore;
  forceKycStore: ForceKycStore;
  metagamesStore: MetagamesStore;
  hammersStore: HammersStore;
  prizeDropStore: PrizeDropStore;
  puzzleStore: PuzzleStore;
  liveGeoStore: LiveGeoStore;
  locationStore: LocationStore;
  recentlyPlayedStore: RecentlyPlayedStore;
  extendedOfferStore: ExtendedOfferStore;
  gamesSearchStore: GamesSearchStore;
  riveFileStore: RiveFileStore;
  marketingConsentStore: MarketingConsentStore;
  userSnappyGiftsStore: UserSnappyGiftsStore;
  trailStore: TrailStore;
  regionStore: RegionStore;
  plinkoStore: PlinkoStore;
  rouletteStore: RouletteStore;
  subscriptionStore: SubscriptionStore;
  bingoStore: BingoStore;
  gameUiStore: GameUiStore;
  metagamesWarmStore: MetagamesWarmStore;
  challengesStore: ChallengesStore;
  monetizationEventsStore: MonetizationEventsStore;
  sportEventsStore: SportEventsStore;
  sofStore: SofStore;
  actionEventTriggerStore: ActionEventTriggerStore;
  widgetsStore: WidgetsStore;
  cashOfferStore: CashOfferStore;
  jackpotStore: JackpotStore;

  constructor() {
    // AuthStore should be created before other stores
    this.authStore = new AuthStore(this);

    // Debug env tool (dev-only). Instantiated early so GameUiStore can read it.
    this.debugEnvStore = new DebugEnvStore();

    // Other stores
    this.appStore = new AppStore(this);
    this.categoriesStore = new CategoriesStore(this);
    this.cmsStore = new CmsStore(this);
    this.configStore = new ConfigStore(this);
    this.gameStore = new GameStore(this);
    this.onboardingStore = new OnboardingStore(this);
    this.portalStore = new PortalStore(this);
    this.uiStore = new UiStore(this);
    this.userStore = new UserStore(this);
    this.rewardsStore = new RewardsStore(this);
    this.walletStore = new WalletStore(this);
    this.payRedeemStore = new PayRedeemStore(this);
    this.coinTypeStore = new CoinTypeStore(this);
    this.crownRipsStore = new CrownRipsStore(this);
    this.wizardStore = new WizardStore();
    this.liveGeoStore = liveGeoStore;
    this.locationStore = new LocationStore(this);
    this.landingStore = new LandingStore(this);
    this.eventTriggerStore = new EventTriggerStore(this);
    this.loyaltyProgramStore = new LoyaltyProgramStore(this);
    this.tournamentOfChampionsStore = new TournamentOfChampionsStore(this);
    this.tournamentStore = new TournamentStore(this);
    this.dailyMissionsStore = new DailyMissionsStore(this);
    this.missionsStore = new MissionsStore(this);
    this.promotionStore = new PromotionStore(this);
    this.termsOfServiceStore = new TermsOfServiceStore(this);
    this.coinBackStore = new CoinBackStore(this);
    this.minigamesStore = new MinigamesStore(this);
    this.animationStore = new AnimationStore();
    this.notificationStore = new NotificationsStore(this);
    this.userFreeSpinsStore = new UserFreeSpinsStore(this);
    this.pocStore = new PocStore(this);
    this.sofStore = new SofStore(this);
    this.lowBalanceStore = new LowBalanceStore(this);
    this.questStore = new QuestStore(this);
    this.stampCardStore = new StampCardStore(this);
    this.forceKycStore = new ForceKycStore(this);
    this.metagamesStore = new MetagamesStore(this);
    this.hammersStore = new HammersStore(this);
    this.prizeDropStore = new PrizeDropStore(this);
    this.puzzleStore = new PuzzleStore(this);
    this.recentlyPlayedStore = new RecentlyPlayedStore();
    this.extendedOfferStore = new ExtendedOfferStore(this);
    this.gamesSearchStore = new GamesSearchStore(this);
    this.riveFileStore = new RiveFileStore();
    this.marketingConsentStore = new MarketingConsentStore(this);
    this.userSnappyGiftsStore = new UserSnappyGiftsStore(this);
    this.trailStore = new TrailStore(this);
    this.regionStore = new RegionStore(this);
    this.plinkoStore = new PlinkoStore(this);
    this.rouletteStore = new RouletteStore(this);
    this.subscriptionStore = new SubscriptionStore(this);
    this.bingoStore = new BingoStore(this);
    this.gameUiStore = new GameUiStore(this);
    this.metagamesWarmStore = new MetagamesWarmStore(this);
    this.challengesStore = new ChallengesStore(this);
    this.monetizationEventsStore = new MonetizationEventsStore(this);
    this.sportEventsStore = new SportEventsStore(this);
    this.actionEventTriggerStore = new ActionEventTriggerStore(this);
    this.widgetsStore = new WidgetsStore(this);
    this.cashOfferStore = new CashOfferStore(this);
    this.jackpotStore = new JackpotStore(this);
    // should be last
    this.featureManagerStore = new FeatureManagerStore(this);
  }
}
